var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-header"},[_c('img',{attrs:{"src":require("../../../../static/version2/左边板块标题样式.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }